import React from 'react';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import KpiFlakyTestsUnified from './KpiFlakyTestsUnified';
import KpiPullRequests from './KpiPullRequests';
import KpiOpenPullRequests from './KpiOpenPullRequests';
import KpiBugsBySprint from './KpiBugsBySprint';
import KpiBugsBySprintStatus from './KpiBugsBySprintStatus';
import KpiBugsResolutionRateBySquad from './KpiBugsResolutionRateBySquad';
import KpiBugsMTTRBySquad from './KpiBugsMTTRBySquad';
import KpiTestEfficiency from './KpiTestEfficiency';
import KpiTopFailedTests from './KpiTopFailedTests';
import KpiDisabledTests from './KpiDisabledTests';
import KpiSquadSocleFrontMTTD from './KpiSquadSocleFrontMTTD';
import KpiSquadSocleFrontPRMergeTime from './KpiSquadSocleFrontPRMergeTime';
import KpiSquadSocleFrontBugMetrics from './KpiSquadSocleFrontBugMetrics';
import KpiWorkItemsCompleted from './KpiWorkItemsCompleted';
import KpiPBIDevToDoneTime from './KpiPBIDevToDoneTime';
import KpiCreatedBugs from './KpiCreatedBugs';
import KpiBugDevToDoneTime from './KpiBugDevToDoneTime';
import KpiTimeInTest from './KpiTimeInTest';
import KpiTimeInTestBySprint from './KpiTimeInTestBySprint';
import KpiBugsByPerson from './KpiBugsByPerson';
import KpiDemandesClient from './KpiDemandesClient';
import KpiDemandesClientDevToDoneTime from './KpiDemandesClientDevToDoneTime';
import KpiTestCreatedCount from './KpiTestCreatedCount';
import KpiTaEvolutionStatic from './KpiTaEvolutionStatic';
import KpiPlannedRelease261 from './KpiPlannedRelease261';

const THEME_TABS = [
  { key: 'generals',          label: 'Générals' },
  { key: 'qa',                label: 'QA' },
  { key: 'squad-socle-front', label: 'Squad Socle Front' },
  { key: 'demandes-client',   label: 'Demandes client' },
];

export default function KpisPage() {
  const { theme } = useParams();
  const selectedTheme = theme || 'generals';

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Header */}
      <div className="bg-white border-b border-gray-200 sticky top-0 z-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between py-4">
            <div>
              <h1 className="text-2xl font-bold text-gray-900">KPIs</h1>
              <p className="text-sm text-gray-500 mt-0.5">Indicateurs clés de performance</p>
            </div>
          </div>
          {/* Tabs */}
          <div className="flex gap-0 border-t border-gray-100 -mx-4 px-4 overflow-x-auto">
            {THEME_TABS.map(tab => (
              <Link
                key={tab.key}
                to={'/kpis/' + tab.key}
                className={'py-3 px-4 text-sm font-medium whitespace-nowrap border-b-2 transition-colors ' +
                  (selectedTheme === tab.key
                    ? 'border-blue-600 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300')}
              >
                {tab.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
      {/* Content */}
      <div className="max-w-7xl mx-auto py-8 space-y-6 px-4 sm:px-6 lg:px-8">
        {/* KPIs Générals */}
        {selectedTheme === 'generals' && (
          <>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              <KpiBugsBySprint />
              <KpiBugsBySprintStatus />
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              <KpiBugsResolutionRateBySquad />
              <KpiBugsMTTRBySquad />
            </div>
            <KpiWorkItemsCompleted />
            <KpiPBIDevToDoneTime />
            <KpiCreatedBugs />
            <KpiBugDevToDoneTime />
            <KpiTimeInTest />
            <KpiTimeInTestBySprint />
            <KpiDemandesClientDevToDoneTime />
          </>
        )}

        {/* KPIs QA */}
        {selectedTheme === 'qa' && (
          <>
            <KpiTestEfficiency />
            <KpiTopFailedTests />
            <KpiFlakyTestsUnified />
            <KpiDisabledTests />
            <KpiTaEvolutionStatic />
            <KpiTestCreatedCount />
            <KpiOpenPullRequests />
            <KpiPullRequests />
            <KpiBugsByPerson />
          </>
        )}

        {/* KPIs Squad Socle Front */}
        {selectedTheme === 'squad-socle-front' && (
          <>
            <KpiSquadSocleFrontMTTD />
            <KpiSquadSocleFrontPRMergeTime />
            <KpiSquadSocleFrontBugMetrics />
          </>
        )}

        {selectedTheme === 'demandes-client' && (
          <>
            <KpiDemandesClientDevToDoneTime />
            <KpiDemandesClient />
          </>
        )}
      </div>
    </div>
  );
}
